import { parseISO, format } from 'date-fns';

import React, { useState, useEffect, Fragment } from 'react';

import { Grid, Typography, CardContent, Card, Chip } from '@material-ui/core';

const History = ({ history }) => {
  return (
    <Card>
      <CardContent
        style={{
          paddingTop: 0,
          paddingBottom: 0,
          paddingRight: 0
        }}>
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
          spacing={2}
          style={{ padding: 10 }}
          wrap="nowrap">
          <Grid item style={{ maxWidth: 50 }}>
            <Typography variant={'body2'} style={{ fontSize: 12 }}>
              {`${format(parseISO(history.date), 'dd.MM HH:mm')} `}
            </Typography>
          </Grid>
          <Grid item zeroMinWidth>
            <Chip
              size="small"
              label={history.amount.toLocaleString('ru')}
              color={history.amount < 0 ? 'primary' : 'default'}
            />
          </Grid>
          <Grid item zeroMinWidth>
            <Typography variant={'body1'} noWrap>
              {`${history.meta.actor ? history.meta.actor : ''} `}
            </Typography>
          </Grid>
          <Grid item xs>
            <Typography variant={'body1'}>{`${history.comment} `}</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default History;
